export enum UploadDocumentType {
  LIST = 'LIST',
  PITCHDECK = 'PITCHDECK',
}
